module.exports = __webpack_public_path__ + "static/clonex-b74d101f3787ae3d1f429794c662fbbb.webm";